const translations = {
    inputSearch: {
        type: 'text',
        defaultValue: 'Jakiej firmy do rozwoju mentalnego szukasz?',
    },
    selectCategories: {
        type: 'text',
        defaultValue: 'Wszystkie kategorie',
    },
    emptyResultsTextOne: {
        type: 'text',
        defaultValue: 'Zmień kryteria wyszukiwania lub',
    },
    emptyResultsButton: {
        type: 'text',
        defaultValue: ' wyczyść filtry ',
    },
    emptyResultsTextTwo: {
        type: 'text',
        defaultValue: 'aktualnie ustawione.',
    },
    emptyResultsInfo: {
        type: 'text',
        defaultValue: 'Brak wyników dla wybranych filtrów',
    },
};

export default translations;
